import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Event Subscriptions`}</h2>
    <p>{`Return to the browser tab for the Slack app. `}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Event Subscriptions`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the `}<inlineCode parentName="p">{`Enable Events`}</inlineCode>{` section, click the slider to enable events. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`For the Request URL field use the `}<inlineCode parentName="p">{`Request URL`}</inlineCode>{` from step 5.`}</p>
        <p parentName="li">{`e.g: `}<inlineCode parentName="p">{`https://<my-url>/aiops/aimanager/instances/xxxxx/api/slack/events`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After pasting the value in the field, a `}<em parentName="p">{`Verified`}</em>{` message should display.`}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slacki3.png",
          "alt": "slacki3"
        }}></img>
        <p parentName="li">{`If you get an error on versions prior to 4.0 please check that you have followed `}<a parentName="p" {...{
            "href": "https://niklaushirt.github.io/ibm-aiops-training/06-configure-aimanager/06-configure-aimanager-09/"
          }}>{`this`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify that on the `}<inlineCode parentName="p">{`Subscribe to bot events`}</inlineCode>{` section you got:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`app_mention`}</inlineCode>{` and `}</li>
          <li parentName="ul"><inlineCode parentName="li">{`member_joined_channel`}</inlineCode>{` events.`}</li>
        </ul>
        <img parentName="li" {...{
          "src": "./../images/slack/slacki4.png",
          "alt": "slacki4"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Save Changes`}</inlineCode>{` button.`}</p>
      </li>
    </ol>
    <h2>{`📥 STEP: Interactivity & Shortcuts`}</h2>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Interactivity & Shortcuts`}</inlineCode>{`. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the Interactivity section, click the slider to enable interactivity. For the `}<inlineCode parentName="p">{`Request URL`}</inlineCode>{` field, use use the URL from above.`}</p>
        <p parentName="li"><strong parentName="p">{`There is no automatic verification for this form`}</strong></p>
        <img parentName="li" {...{
          "src": "./../images/slack/slacki5.png",
          "alt": "slacki5"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Save Changes`}</inlineCode>{` button.`}</p>
      </li>
    </ol>
    <h2>{`📥 STEP: Slash Commands`}</h2>
    <p>{`Now, configure the `}<inlineCode parentName="p">{`welcome`}</inlineCode>{` slash command. With this command, you can trigger the welcome message again if you closed it. `}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Select  `}<inlineCode parentName="p">{`Slash Commands`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create New Command`}</inlineCode>{` to create a new slash command. `}</p>
        <p parentName="li">{`Use the following values:`}</p>
        <table parentName="li">
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Field`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Value`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Command`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`/welcome`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Request URL`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`the URL from above`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Short Description`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Welcome to CloudPak for AIOps`}</td>
            </tr>
          </tbody>
        </table>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Save`}</inlineCode>{`.`}</p>
      </li>
    </ol>
    <h2>{`📥 STEP: Reinstall App`}</h2>
    <p>{`The Slack app must be reinstalled, as several permissions have changed. `}</p>
    <ol>
      <li parentName="ol">{`Select `}<inlineCode parentName="li">{`Install App`}</inlineCode>{` `}</li>
      <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Reinstall to Workspace`}</inlineCode></li>
    </ol>
    <p>{`Once the workspace request is approved, the Slack integration is complete. `}</p>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p>{`You have successfully finished this Chapter.`}</p>
      <p><strong parentName="p">{`You are now done with the chapter on  Configuring Slack`}</strong></p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      